import React, { useState, useEffect, useRef } from 'react';

// Carrousel de photos réutilisable, avec swipe tactile et défilement automatique.
function PhotoCarousel({ photos, alt }) {
  const [index, setIndex] = useState(0);
  const touchStart = useRef(0);
  const touchEnd = useRef(0);

  useEffect(() => {
    if (photos.length <= 1) return;
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % photos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [photos.length]);

  const handleTouchStart = (e) => {
    touchStart.current = e.changedTouches[0].screenX;
  };

  const handleTouchEnd = (e) => {
    touchEnd.current = e.changedTouches[0].screenX;
    const diff = touchStart.current - touchEnd.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setIndex(prev => (prev + 1) % photos.length);
      else setIndex(prev => (prev - 1 + photos.length) % photos.length);
    }
  };

  if (photos.length === 0) return null;

  return (
    <div className="carousel" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      {photos.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={`${alt} ${i + 1}`}
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}

      {photos.length > 1 && (
        <div className="carousel-dots">
          {photos.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default PhotoCarousel;
